import {
    buyTopRequest,
    buyAdvertsRequest,
} from '../../../services/network/common/top';

class TopService {
    async buyTop(values) {
        return await buyTopRequest(values);
    }

    async buyAdverts(values) {
        return await buyAdvertsRequest(values);
    }

    async buyPremium(values) {
        return await buyAdvertsRequest(values);
    }
}

export const BuyTopService = new TopService();
